import styled, { css, keyframes } from 'styled-components';
import pulseKeyframes from '../../../styles/pulseKeyframes';
var fadeIn = keyframes(["0%{opacity:0.4;}100%{opacity:1;}"]);
var Image = styled.img.withConfig({
  displayName: "Image",
  componentId: "tv4uhw-0"
})(["animation:", " 0.3s ease-in-out;", " ", ""], fadeIn, function (_ref) {
  var isLoading = _ref.isLoading;
  return isLoading && css(["animation:", " 1s infinite ease-in-out;"], pulseKeyframes);
}, function (_ref2) {
  var imageFluid = _ref2.imageFluid;
  return imageFluid && css(["height:auto;max-width:100%;"]);
});
export default Image;